import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { isAxiosError } from "axios";
import { http } from "@silvertours/front-shared";
var LoginError;
(function(LoginError) {
    LoginError["Blocked"] = "blocked";
    LoginError["ExpiredPassword"] = "expiredPassword";
    LoginError["Unauthorized"] = "unauthorized";
    LoginError["Unknown"] = "unknown";
    LoginError["UnverifiedEmail"] = "unverifiedEmail";
    LoginError["Validation"] = "validation";
    LoginError["WeakPassword"] = "weakPassword";
})(LoginError || (LoginError = {}));
var handleLoginError = function(error) {
    switch(error){
        case "/general/errors/bad-request":
        case "/auth/errors/login/bad-request":
        case "/auth/errors/login/invalid-credentials":
            return LoginError.Validation;
        case "/auth/errors/login/expired-password":
            return LoginError.ExpiredPassword;
        case "/auth/errors/login/unverified-email":
            return LoginError.UnverifiedEmail;
        case "/auth/errors/login/weak-password":
            return LoginError.WeakPassword;
        case "/general/errors/undefined":
        case "/auth/errors/login/undefined":
        default:
            return LoginError.Unknown;
    }
};
var getAccountSession = function() {
    var _ref = _async_to_generator(function(url) {
        var res;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        http.axiosInstance.get(url, {
                            withCredentials: true,
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function getAccountSession(url) {
        return _ref.apply(this, arguments);
    };
}();
var updateAccountSession = function() {
    var _ref = _async_to_generator(function(url, accessToken, refreshToken) {
        var res;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        http.axiosInstance.post(url, {
                            access_token: accessToken,
                            refresh_token: refreshToken
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.status === 204
                    ];
            }
        });
    });
    return function updateAccountSession(url, accessToken, refreshToken) {
        return _ref.apply(this, arguments);
    };
}();
var login = function() {
    var _ref = _async_to_generator(function(url, urlSession, username, password, whitelabel) {
        var res, error, ref;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        http.axiosInstance.post(url, {
                            username: username,
                            password: password
                        }, {
                            headers: {
                                "X-Whitelabel": whitelabel
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (!(res.status >= 200 && res.status <= 299)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        updateAccountSession(urlSession, res.data.access_token, res.data.refresh_token)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        {
                            loggedIn: true
                        }
                    ];
                case 4:
                    error = _state.sent();
                    if (isAxiosError(error)) {
                        ;
                        return [
                            2,
                            {
                                loggedIn: false,
                                error: handleLoginError((ref = error.response) === null || ref === void 0 ? void 0 : ref.data.type)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            loggedIn: false,
                            error: LoginError.Unknown
                        }
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function login(url, urlSession, username, password, whitelabel) {
        return _ref.apply(this, arguments);
    };
}();
var resendConfirmUser = function() {
    var _ref = _async_to_generator(function(url, emailAddress, whitelabel) {
        var res, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        http.axiosInstance.post(url, {
                            email_address: emailAddress
                        }, {
                            headers: {
                                "X-Whitelabel": whitelabel
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.status === 204
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function resendConfirmUser(url, emailAddress, whitelabel) {
        return _ref.apply(this, arguments);
    };
}();
export { login, getAccountSession, resendConfirmUser, LoginError };
